import {
  ModalActionTypes,
  ModalTypes,
  ProductTypeSwitchModalAction,
  ProductTypeSwitchRemovalReason,
} from '../types';

export const productTypeSwitchModalAction = (
  cids: number[],
  accept: () => void,
  reason: ProductTypeSwitchRemovalReason
): ProductTypeSwitchModalAction => ({
  type: ModalActionTypes.SHOW,
  modalType: ModalTypes.PRODUCT_TYPE_SWITCH,
  props: { cids, accept, reason },
});
